import { useEffect, useRef } from 'react';
import type { ChatMessage } from '../lib/types';
import { MessageBubble } from './MessageBubble';

export function MessageList({
  messages,
  loading,
  company,
  division,
}: {
  messages: ChatMessage[];
  loading: boolean;
  company?: string;
  division?: string;
}) {
  const endRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    endRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages, loading]);

  return (
    <div className="messages">
      {messages.length === 0 && (
        <div className="empty">
          <p>Stel een vraag aan Nina, of plak een klant-e-mail om een concept-antwoord op te stellen.</p>
        </div>
      )}
      {messages.map((m, i) => (
        <MessageBubble
          key={m.id}
          message={m}
          // The user turn immediately before this answer is what a correction
          // gets filed under, so the entry matches how the question was asked.
          question={m.role === 'assistant' ? messages[i - 1]?.content : undefined}
          company={company}
          division={division}
        />
      ))}
      {/* Only show the typing dots while nothing is on screen yet. Once the
          stream opens, the assistant bubble exists and fills in as text
          arrives — showing both put an empty second bubble under the answer. */}
      {loading && messages[messages.length - 1]?.role !== 'assistant' && (
        <div className="bubble bubble-nina">
          <div className="bubble-head">
            <span className="nina-dot" aria-hidden>⬤</span>
            <span className="nina-name">Nina</span>
          </div>
          <div className="typing"><span></span><span></span><span></span></div>
        </div>
      )}
      <div ref={endRef} />
    </div>
  );
}
